import React, { useState } from "react";
import axios from "axios";
import { BASEURL } from "../Config";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import swal from "sweetalert";
import { NavLink } from "react-router-dom";

const AddClasses = () => {
    const [data, setData] = useState([{ name: "" }]);

    const handleChange = (e, idx) => {
        const { name, value } = e.target;
        const newData = [...data];
        newData[idx][name] = value;
        if (name === "name") {
            newData[idx]["nameError"] = false;
        } else if (name === "classno") {
            newData[idx]["classError"] = false;
        } else if (name === "subject") {
            newData[idx]["subjectError"] = false;
        }

        setData(newData);
    };

    const handleOnAddClass = (e) => {
        e.preventDefault();
        setData([...data, { name: "", classno: 0, subject: "" }]);
    };

    const handleOnDeleteClass = (e, idx) => {
        e.preventDefault();
        const newData = [...data];
        newData.splice(idx, 1);
        setData(newData);
    };

    const validateData = () => {
        let error = false;
        const newData = [...data];
        newData.forEach((item) => {
            if (item.name === "") {
                item.nameError = true;
                error = true;
            }
        });
        setData(newData);
        return error;
    };

    const handleSubmit = () => {
        if (validateData()) {
            swal("Error in Adding Classes", "Fill the required fields", "error");
        } else {
            console.log('data', data)
            axios
                .post(`${BASEURL}/api/v1/elp/classes/save-all`, data)
                .then((res) => {
                    if (res.status === 200) {
                        swal("Success", "Classes Added successfully", "success").then(() => {
                            window.location = "classes";
                        });
                    } else {
                        console.log("res", res);
                    }
                })
                .catch((err) => {
                    swal("Error in Adding Classes", err.response.data, "error");
                    console.log("Create Classes Error", err);
                });
        }
    };

    return (
        <div id="wrapper">
            <Sidebar act="classes" />
            <div className="content-page">
                <div className="content">
                    <Topbar act="Add Classes" breadcrumbItems={["ELP", { label: 'Classes', path: '/classes' }, "Add New Classess"]} />
                    <div className="container-fluid main-container">

                        <div className="row">
                            <div className="col-12">
                                <div className="card main-card">
                                    <div className="card-body">
                                        {data.map((item, idx) => (
                                            <div className="row" key={idx}>
                                                <div className="col-xl-3">
                                                    <div className="mb-3">
                                                        {idx === 0 && (
                                                            <label htmlFor="classname" className="form-label">
                                                                Class Name
                                                            </label>
                                                        )}
                                                        <input
                                                            type="text"
                                                            id="classname"
                                                            className="form-control"
                                                            onChange={(e) => handleChange(e, idx)}
                                                            name="name"
                                                            placeholder="Enter Class Name"
                                                            value={item.name}
                                                        />
                                                        {item.nameError && <p className="errTxt">* required</p>}
                                                    </div>
                                                </div>
                                               
                                                <div className="col-xl-3">
                                                    {idx === 0 && (
                                                        <label htmlFor="actions" className="form-label">
                                                            Actions
                                                        </label>
                                                    )}
                                                    <div className="mb-3">
                                                        <button
                                                            className="btn btn-danger"
                                                            onClick={(e) => handleOnDeleteClass(e, idx)}
                                                        >
                                                            <i className="mdi mdi-minus-circle" /> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="mb-2">
                                            <button
                                                className="btn btn-success table_Action_btns"
                                                onClick={(e) => handleOnAddClass(e)}
                                            >
                                                <i className="mdi mdi-plus-circle" /> Add Class
                                            </button>
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-customprimary"
                                            onClick={() => handleSubmit()}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default AddClasses;
